
//  custom jQuery start

jQuery( document ).ready(function(e) {
  
  $('.register-link a').click(function(e){
    e.preventDefault();
    $('html, body').animate({scrollTop: $($(this).attr("href")).offset().top}, 500);
    return false;
  });
    
});


// Image Hover Change

$('.image-hover').on('mouseenter', function(){
  let newImage = $(this).data('hover');

  $(this).css({"background-image":"url("+newImage+")"});
  
});

$('.image-hover').on('mouseout', function(){
  let oldImage = $(this).data('original');

  $(this).css({"background-image":"url("+oldImage+")"});
  
});